// @ts-ignore
import type { IOnboardingGetOrgProfileResponse } from '@bb/users';
import axios from 'axios';
import type { PortalWithAssociationDataConfig } from '../../Router/onboarding/types';

export type OnboardingPortalWithOrgs = PortalWithAssociationDataConfig & {
  orgs: {
    id: string;
    name: string;
    address: IOnboardingGetOrgProfileResponse['firstActiveAddress'];
    claimHash?: string;
    isClaimed?: boolean;
  }[];
};

const onboardingPortal = async (hash: string) => {
  // TODO: Update domain
  const { data } = await axios.get<OnboardingPortalWithOrgs>(
    `/org/onboarding_portal_orgs/${hash}`,
  );

  return data;
};

export default onboardingPortal;
